import { useMutation, useQueryClient } from "@tanstack/react-query";

import { patchDocument } from "@/api/documents";

interface Args {
  tradeKey: string | null;
}

export function useUpdateDocument(documentId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: Args) => patchDocument(documentId, body),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ["document", documentId] });
      void qc.invalidateQueries({ queryKey: ["emails"] });
      void qc.invalidateQueries({ queryKey: ["email"] });
    },
  });
}
